// extracted by mini-css-extract-plugin
module.exports = {"box-size":"_BaseRadio_box-size_1J72o","box":"_BaseRadio_box_szIPi","circle":"_BaseRadio_circle_3KEIW","checked":"_BaseRadio_checked_H2XFJ"};